import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { NewPhoneFlow } from "@/features/auth/NewPhoneFlow";
import { meQuery } from "@/lib/auth";

// Nieuwe telefoon koppelen (H-g02): with the password; the old phone works until the new one is right.

export const Route = createFileRoute("/_portal/account/phone")({
  component: NewPhoneScreen,
});

function NewPhoneScreen() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: me } = useSuspenseQuery(meQuery);
  return (
    <div className="wl-auth" data-screen-label="Portaal Nieuwe telefoon">
      <div className="wl-auth__card wl-auth__card--wide">
        <NewPhoneFlow
          me={me}
          forced={false}
          onCancel={() => void navigate({ to: "/shipments" })}
          onDone={(linked) => {
            queryClient.setQueryData(meQuery.queryKey, linked);
            void navigate({ to: "/shipments" });
          }}
        />
      </div>
    </div>
  );
}
